export function getOsanoScriptUrl(): string | undefined {
  const url = process.env.NEXT_PUBLIC_OSANO_SCRIPT_URL?.trim();
  return url || undefined;
}
